<template>
  <div v-if="shippingGroups.length" class="checkout-total-widget">
    <shipping-group-total
      v-for="(group, ind) of shippingGroups"
      :key="group.name"
      :index="ind"
      :group="group"
      :thirdparty-store="THIRDPARTY_STORES[group.thirdPartyId]"
      class="checkout-total-widget__group"
    />

    <div class="checkout-total-widget__to-pay">
      <span>Всего к оплате</span>
      <div class="checkout-total-widget__total-price">
        <span v-if="price.old" class="checkout-total-widget__old-price">
          {{ price.old | price }}
        </span>
        <span>{{ price.current | price }} ₽</span>
      </div>
    </div>

    <ui-button
      :text="submitText"
      wide
      class="checkout-total-widget__submit"
      @click="$emit('submit')"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { pluralize } from '@/utils/string-utils';

import ShippingGroupTotal from '@/components/checkout/checkout-total-widget/shipping-group-total.vue';

export default {
  name: 'checkout-total-widget',

  components: {
    ShippingGroupTotal,
  },

  computed: {
    ...mapState({
      CART_DETAILS: state => state.cart.cartDetails,
    }),
    ...mapGetters({
      SHIPPING_GROUPS: 'cart/shippingGroups',
      SUBTOTAL: 'cart/subtotal',
      THIRDPARTY_STORES: 'cart/thirdpartyStores',
    }),

    shippingGroups() {
      return this.SHIPPING_GROUPS
        .filter(group => group.type !== 'soldout');
    },

    submitText() {
      const count = this.shippingGroups.length;
      return `Оформить ${pluralize(count, ['заказ', 'заказа', 'заказов'], count < 2)}`;
    },

    price() {
      return {
        current: +this.SUBTOTAL || 0,
        old: +this.CART_DETAILS.subtotal || 0,
      };
    },
  },
};
</script>

<style lang="scss">
.checkout-total-widget {
  &__to-pay {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    height: 60px;
    padding: 12px;
    margin-bottom: 16px;
    border: 2px solid $blue_40;
    border-radius: 4px;
    background: $white;
    font-size: 16px;
    line-height: 24px;
    color: $black;
    font-weight: 600;
  }

  &__total-price {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    white-space: nowrap;
  }

  &__old-price {
    font-size: 12px;
    line-height: .5;
    font-weight: 400;
    text-decoration: line-through;
    color: $gray;
  }

  &__group {
    margin-bottom: 16px;
  }
}

@include breakpoint("desktop") {
  .checkout-total-widget {
    &__to-pay {
      padding: 12px 20px;
    }
  }
}
</style>
